export const UNLIMITED_CUSTOMERS = 1000000;
